import React, { useState, useEffect } from "react";
import {
  Typography,
  Grid,
  Avatar,
  Card,
  Box,
  Collapse,
  Button,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { setDeviceToken } from "../../../redux/slices/notification.slice";
import { useLocation, useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-hot-toast";
import { toastoptions } from "../../../utils/toastoptions";
import { reduxSetUserLoggedInInfo } from "../../../redux/loggedInInfo/loggedIn.slice";
import { getStudentByIdAsync } from "../../../redux/async.api";
import { switchProductAsync } from "../../../redux/loggedInInfo/loggedIn.async";

const GoalList = ({
  item,
  expandedCourseId,
  setExpandedCourseId,
  goalLoader,
  setOpen,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedSteps, setSelectedSteps] = useState({});
  const [currentStep, setCurrentStep] = useState(item.next_step);
  const [steps, setSteps] = useState([]);
  const systemToken = useSelector((state) => state?.notification?.deviceToken);
  const { switchGoalLoader } = useSelector((state) => state?.userInfo);

  const handleExpand = (courseId) => {
    setExpandedCourseId((prev) => (prev === courseId ? null : courseId));
    setSelectedSteps({});
    setSteps([]);
  };

  const handleStepSelection = (stepKey, value) => {
    let availableOptions = item[stepKey] || [];

    if (!availableOptions.length) {
      const parentStep = steps[steps.indexOf(stepKey) - 1];
      const parentData = selectedSteps[parentStep]?.data;

      if (parentData && parentData[stepKey]) {
        availableOptions = parentData[stepKey];
      }
    }

    const selectedData = availableOptions.find((option) => option.id === value);

    if (!selectedData) return;

    setSelectedSteps((prev) => {
      let updatedSteps = {
        ...prev,
        [stepKey]: { id: value, data: selectedData },
      };

      // Remove all downstream steps when a parent is changed
      Object.keys(prev).forEach((key) => {
        if (steps.indexOf(key) > steps.indexOf(stepKey)) {
          delete updatedSteps[key];
        }
      });

      return updatedSteps;
    });

    // Move to the next step
    if (selectedData?.next_step && selectedData.next_step !== "none") {
      setCurrentStep(selectedData.next_step);
    }
  };

  // Check if the "Continue" button should be visible
  const shouldShowContinueButton = () => {
    const lastStep = steps[steps.length - 1];
    const lastStepData = selectedSteps[lastStep]?.data;

    return lastStepData?.next_step === "none";
  };

  const getStepData = (stepKey) => {
    if (!item[stepKey]) {
      const parentStep = steps[steps.indexOf(stepKey) - 1];
      const parentData = selectedSteps[parentStep]?.data;

      return parentData?.[stepKey] || [];
    }
    return item[stepKey] || [];
  };

  useEffect(() => {
    if (expandedCourseId === item?.id) {
      const dynamicSteps = [];
      let currentStepKey = item.next_step;

      while (currentStepKey && currentStepKey !== "none") {
        dynamicSteps.push(currentStepKey);

        const currentStepData = selectedSteps[currentStepKey]?.data;
        currentStepKey = currentStepData?.next_step || null;
      }

      setSteps(dynamicSteps);
      setCurrentStep(dynamicSteps[0]);
    }
  }, [expandedCourseId, selectedSteps]);

  const getSelectedGoalId = () => {
    if (steps.length === 0) return null;

    const lastStep = steps[steps.length - 1];
    const lastStepData = selectedSteps[lastStep]?.data;

    return lastStepData?.goalId || null;
  };

  const handleSwitchProduct = (goalId) => {
    const payload = {
      deviceType: "Web",
      // deviceToken: systemToken,
      deviceToken: "",
      goalId: goalId,
    };

    dispatch(switchProductAsync(payload)).then((res) => {
      if (res?.payload?.status == 200) {
        dispatch(setDeviceToken(res?.payload?.data?.accessToken));
        localStorage.setItem(
          "auth",
          JSON.stringify({
            accessToken: res?.payload?.data?.accessToken,
            userId: res?.payload?.data?.id,
          }),
        );
        dispatch(
          reduxSetUserLoggedInInfo({
            accessToken: res?.payload?.data?.accessToken,
            userId: res?.payload?.data?.id,
            loginStatus: res?.payload?.data?.loginStatus,
          }),
        );
        // const studentPayload = {
        //   userId: res?.payload?.data?.id,
        // };
        // dispatch(getStudentByIdAsync(studentPayload));
        navigate("/app/dashboard", { state: { goalId: goalId } });
        setOpen(false);
      }
    });
  };

  return (
    <Grid item xs={12} md={6} sx={{ bgcolor: "white" }}>
      <Card
        sx={{
          height: "auto",
          marginLeft: "12px",
          marginRight: "12px",
          p: "5px 10px",
          pb: "10px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            width: { sm: "100%", md: "700px" },
          }}
          onClick={() => handleExpand(item?.id)}
        >
          <Box sx={{ width: "25%", padding: "10px", cursor: "pointer" }}>
            <Avatar
              alt="avatar"
              src={item.image}
              sx={{ width: 50, height: 50 }}
            />
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
              pl: 1,
            }}
          >
            <Box
              sx={{
                width: "80%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "flex-start",
                cursor: "pointer",
              }}
            >
              <Typography sx={{ fontSize: "16px", fontWeight: 600, mb: "3px" }}>
                {item.name}
              </Typography>
              <Typography
                sx={{
                  color: "#161A1F",
                  opacity: 0.6,
                  fontSize: "12px",
                  fontWeight: 500,
                }}
                className="course-des"
                dangerouslySetInnerHTML={{
                  __html: item.shortDescription,
                }}
              ></Typography>
            </Box>

            <Box
              onClick={(event) => {
                event.stopPropagation();
                handleExpand(item?.id);
              }}
              sx={{ cursor: "pointer" }}
            >
              {expandedCourseId === item.id ? (
                <ExpandLessIcon sx={{ opacity: 0.6 }} />
              ) : (
                <ExpandMoreIcon sx={{ opacity: 0.6 }} />
              )}
            </Box>
          </Box>
        </Box>
        <Collapse in={expandedCourseId === item.id} unmountOnExit>
          <Box sx={{ width: "100%", height: "auto", pt: 1, pb: 1 }}>
            <Grid container spacing={1}>
              {steps.map((stepKey) => (
                <Grid key={stepKey} item xs={12}>
                  <Box
                    sx={{
                      width: "100%",
                      height: "auto",
                      borderTop: "1px dashed rgba(22, 26, 31, 0.1)",
                      pt: 2,
                      pb: 1,
                      transition: "height 0.3s ease",
                    }}
                  >
                    <Typography
                      sx={{ fontSize: "12px", color: "#161A1F", opacity: 0.6 }}
                    >
                      Select {stepKey}:{" "}
                    </Typography>
                  </Box>

                  <Grid container spacing={1}>
                    {getStepData(stepKey).map((option) => (
                      <Grid item key={option.id}>
                        <Button
                          variant="contained"
                          sx={{
                            backgroundColor: "#fff",
                            color: "rgba(22, 26, 31, 1)",
                            borderRadius: "46px",
                            fontSize: "12px",
                            border:
                              selectedSteps[stepKey]?.id === option.id
                                ? "1px solid #000"
                                : "1px solid rgba(22, 26, 31, 0.08)",
                            fontWeight:
                              selectedSteps[stepKey]?.id === option.id
                                ? 700
                                : 500,
                            minWidth: { xs: "90px", sm: "120px", md: "90px" },
                            "&:hover": {
                              backgroundColor: "#fff",
                              backgroundColor: "rgba(0, 171, 85, 0.01)",
                              boxShadow: "none",
                            },
                          }}
                          onClick={() =>
                            handleStepSelection(stepKey, option.id)
                          }
                        >
                          {option.name}
                        </Button>
                      </Grid>
                    ))}
                  </Grid>
                </Grid>
              ))}

              {shouldShowContinueButton() && (
                <Grid item xs={12}>
                  <Box sx={{ mt: 3, mb: "2px" }}>
                    <Button
                      variant="contained"
                      disabled={switchGoalLoader ? true : false}
                      sx={{
                        borderRadius: "60px",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: "10px 36px",
                        height: "44px",
                        width: "100%",
                        color: "#ffff",
                        backgroundColor: "#F16B35",
                        "&:hover": {
                          backgroundColor: "#B71D18",
                        },
                      }}
                      onClick={() => {
                        const goalId = getSelectedGoalId();
                        if (goalId) {
                          handleSwitchProduct(goalId);
                        }
                      }}
                    >
                      Continue
                    </Button>
                  </Box>
                </Grid>
              )}
            </Grid>
          </Box>
        </Collapse>
      </Card>
    </Grid>
  );
};

export default GoalList;
